var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-marker-wrapper"},[_c('img',{staticClass:"custom-marker",attrs:{"src":"/themes/custom/ef2_custom/images/marker.png"},on:{"click":_vm.handleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }